
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-741bccae!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LowPriceManagement.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-741bccae&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./LowPriceManagement.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LowPriceManagement.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-741bccae!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LowPriceManagement.vue"),
  /* scopeId */
  "data-v-741bccae",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/orderManagement/LowPriceManagement.vue
// module id = 1531
// module chunks = 3